
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCustomerSurveyPosGrid extends Serenity.EntityGrid<PsCustomerSurveyPosRow, any> {
        protected getColumnsKey() { return PsCustomerSurveyPosColumns.columnsKey; }
        protected getDialogType() { return PsCustomerSurveyPosDialog; }
        protected getIdProperty() { return PsCustomerSurveyPosRow.idProperty; }
        protected getInsertPermission() { return PsCustomerSurveyPosRow.insertPermission; }
        protected getLocalTextPrefix() { return PsCustomerSurveyPosRow.localTextPrefix; }
        protected getService() { return PsCustomerSurveyPosService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}